import { createContext, useContext, useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { fetchCustomAttributeGroups, fetchFlattenedCustomAttributeValues } from '../restapi/customAttributeService';
import { CustomAttributeS } from './CustomAttributeS';

export const CustomAttributesContext = createContext(undefined);

export const CustomAttributesContextProvider = () => {
  const [customAttributeValues, setCustomAttributeValues] = useState();
  const { id: entityId } = useParams();

  const [attributeGroups, setAttributeGroups] = useState();
  const [loadingGroups, setLoadingGroups] = useState(false);

  const [valueLastModified, setValueLastModified] = useState(new Date());
  const [groupsLastModified, setGroupsLastModified] = useState(new Date());

  const refreshValue = () => setValueLastModified(new Date());

  const refreshGroups = () => setGroupsLastModified(new Date());

  const patchAttributeValue = async (attributeId, newValue) => {
    const resJSON = await CustomAttributeS.patchAttributeValue(attributeId, entityId, newValue);
    if (resJSON) {
      setValueLastModified(new Date());
      return true;
    }
    return false;
  };

  useEffect(() => {
    fetchFlattenedCustomAttributeValues('event', entityId).then((resp) => {
      if (resp.ok) {
        resp.json().then((flattenedValues) => {
          setCustomAttributeValues(flattenedValues);
        });
      }
    });
  }, [entityId, valueLastModified]);

  useEffect(() => {
    setLoadingGroups(true);
    fetchCustomAttributeGroups('event')
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((attrs) => {
            setAttributeGroups(attrs);
          });
        }
      })
      .finally(() => setLoadingGroups(false));
  }, [groupsLastModified]);

  return (
    <CustomAttributesContext.Provider
      value={{
        loadingGroups,
        patchAttributeValue,
        customAttributeValues,
        attributeGroups,
        valueLastModified,
        groupsLastModified,
        refreshValue,
        refreshGroups,
      }}
    >
      <Outlet />
    </CustomAttributesContext.Provider>
  );
};

export const useCustomAttributeValue = (attributeId) => {
  const { customAttributeValues } = useContext(CustomAttributesContext);
  if (!customAttributeValues) {
    return null;
  }
  const attributeValue = customAttributeValues.find((value) => value.customAttributeId === attributeId);
  if (!attributeValue) {
    return null;
  }
  return attributeValue.value;
};
